(function () {
  document.querySelectorAll('[data-sauna-quick-pick-expand]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var group = btn.closest('[data-sauna-quick-pick-group]');
      var root = group || btn.closest('[data-sauna-quick-pick]');
      if (!root) return;
      root.classList.add('is-expanded');
      btn.setAttribute('aria-expanded', 'true');
    });
  });

  document.querySelectorAll('.sauna-quick-pick__more:not([data-sauna-quick-pick-expand])').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var popup = document.querySelector('.pdp_variant_popup');
      var overlay = document.querySelector('.pdp_variant_popup_overlay');
      if (popup) popup.classList.add('active_popup');
      if (overlay) overlay.style.display = 'block';
    });
  });

  function bindSaunaFbtToggles() {
    document.querySelectorAll('[data-sauna-fbt-cross-sell]').forEach(function (wrap) {
      // Support multiple rows (up to 3 products) — data-selected & data-bundle-variant-id now live on each row button
      wrap.querySelectorAll('[data-sauna-fbt-toggle]').forEach(function (row) {
        if (row.getAttribute('data-sauna-fbt-bound') === '1') return;
        row.setAttribute('data-sauna-fbt-bound', '1');

        function setSelected(on) {
          row.setAttribute('data-selected', on ? 'true' : 'false');
          row.setAttribute('aria-pressed', on ? 'true' : 'false');
          row.classList.toggle('is-unselected', !on);
        }

        function toggle() {
          var on = row.getAttribute('data-selected') === 'true';
          setSelected(!on);
        }

        row.addEventListener('click', function (e) {
          e.preventDefault();
          toggle();
        });

        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

function saunaProductAddonsOnAdded(ev) {
  var section = ev.target;
  if (!section || !section.matches || !section.matches('[data-section-type="product"]')) return;
  if (window.theme && window.theme.cartType === 'page') return;

  var qty = ev.detail && ev.detail.quantity != null ? parseInt(ev.detail.quantity, 10) : 1;
  if (isNaN(qty) || qty < 1) qty = 1;

  var items = [];

  // FBT — hamesha as-is
  var fbt = section.querySelector('[data-sauna-fbt-cross-sell]');
  if (fbt) {
    fbt.querySelectorAll('[data-sauna-fbt-toggle]').forEach(function (row) {
      if (row.getAttribute('data-selected') === 'true') {
        var fbtVid = parseInt(row.getAttribute('data-bundle-variant-id'), 10);
        if (fbtVid && !isNaN(fbtVid)) items.push({ id: fbtVid, quantity: qty });
      }
    });
  }

  // Extras — sirf tab jab parent-relation OFF ho
  var extrasRoot = section.querySelector('[data-sauna-upsell-extras]');
  if (extrasRoot && extrasRoot.getAttribute('data-use-parent-relation') !== 'true') {
    extrasRoot.querySelectorAll('input.sauna-extras__cb:checked').forEach(function (cb) {
      var id = parseInt(cb.getAttribute('data-variant-id'), 10);
      if (id && !isNaN(id)) items.push({ id: id, quantity: qty });
    });
  }

  if (!items.length) return;

  var base = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
  var addUrl = base.indexOf('.js') !== -1 ? base : base + '.js';
  var body = items.length === 1 ? JSON.stringify(items[0]) : JSON.stringify({ items: items });

  fetch(addUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: body,
  }).then(function (res) {
    if (res.ok) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  });
}

  function initSaunaTabbedGalleries() {
    document.querySelectorAll('[data-sauna-tabbed-gallery]').forEach(function (root) {
      if (root.getAttribute('data-sauna-tabs-bound') === '1') return;
      root.setAttribute('data-sauna-tabs-bound', '1');

      var tabs = root.querySelectorAll('[data-tab-btn]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      if (!tabs.length || !panels.length) return;

      function activate(index) {
        tabs.forEach(function (tab, j) {
          var on = j === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (panel, j) {
          if (j === index) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i);
        });
      });
    });
  }

  function initSaunaProductAddons() {
    bindSaunaFbtToggles();
    initSaunaTabbedGalleries();
    if (!window.__holz4homeSaunaProductAddonsAdded) {
      window.__holz4homeSaunaProductAddonsAdded = true;
      document.documentElement.addEventListener('product:added', saunaProductAddonsOnAdded);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaunaProductAddons);
  } else {
    initSaunaProductAddons();
  }

  document.addEventListener('shopify:section:load', function () {
    bindSaunaFbtToggles();
    initSaunaTabbedGalleries();
  });
})();




(function () {
  const modal    = document.getElementById('sauna-info-modal');
  if (!modal) return;

  const backdrop = modal.querySelector('.sauna-modal__backdrop');
  const closeBtn = modal.querySelector('.sauna-modal__close');
  const titleEl  = modal.querySelector('.sauna-modal__title');
  const bodyEl   = modal.querySelector('.sauna-modal__body');

  let lastTrigger = null;
  let scrollY     = 0;

  function openModal(title, content, trigger) {
    titleEl.textContent = title;
    bodyEl.innerHTML    = content;
    lastTrigger         = trigger;
    modal.hidden        = false;
    trigger.setAttribute('aria-expanded', 'true');

    // scroll lock
    scrollY = window.scrollY;
    document.body.style.position   = 'fixed';
    document.body.style.top        = `-${scrollY}px`;
    document.body.style.width      = '100%';
    document.body.style.overflow   = 'hidden';

    // pointer lock
    document.body.style.pointerEvents = 'none';
    modal.style.pointerEvents          = 'auto';

    closeBtn.focus();
  }

  function closeModal() {
    modal.hidden = false;
    modal.hidden = true;

    // scroll restore
    document.body.style.position   = '';
    document.body.style.top        = '';
    document.body.style.width      = '';
    document.body.style.overflow   = '';
    window.scrollTo(0, scrollY);

    // pointer restore
    document.body.style.pointerEvents = '';
    modal.style.pointerEvents          = '';

    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      lastTrigger.focus();
    }
  }

  // open
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-popup-target]');
    if (!trigger) return;

    const template = document.getElementById(trigger.dataset.popupTarget);
    const content  = template ? template.innerHTML : '';

    openModal(trigger.dataset.popupTitle, content, trigger);
  });

  // close via backdrop, button, or Escape
  backdrop.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // prevent touchmove on body when modal open (iOS)
  document.body.addEventListener('touchmove', function (e) {
    if (!modal.hidden) e.preventDefault();
  }, { passive: false });

})();